<template>
    <div>
        <FilterBar
            cookieName="ProductsFilterOptionsVue"
            :mainFilters="['ProductYearSelector', 'ProductFormatSelector']"
            :secondaryFilters="[]"
            filterBarType="products"
            @change="filtersChanged">
        </FilterBar>

        <div class="content--inner">
            <b-table
                :fields="fields"
                :items="items"
                :class="['product-report-table gk-table gk-table--responsive gk-table--striped gk-table--headed']"
                :busy="loading"
                :key="tableKey"
                show-empty
                table-busy
            >
                <template #cell(group)="data">
                    {{ getGroupName(data.item.group) }}
                </template>

                <template #cell(q1)="data">
                    <div v-if="format === 'eur'" class="text-right">
                        €&nbsp;{{ data.item.q1 | formatNumber }}
                    </div>
                    <div v-if="format === 'quantity'" class="text-right">
                        {{ data.item.q1 ? data.item.q1 : "" }}
                    </div>
                </template>

                <template #cell(q2)="data">
                    <div v-if="format === 'eur'" class="text-right">
                        €&nbsp;{{ data.item.q2 | formatNumber }}
                    </div>
                    <div v-if="format === 'quantity'" class="text-right">
                        {{ data.item.q2 ? data.item.q2 : "" }}
                    </div>
                </template>

                <template #cell(q3)="data">
                    <div v-if="format === 'eur'" class="text-right">
                        €&nbsp;{{ data.item.q3 | formatNumber }}
                    </div>
                    <div v-if="format === 'quantity'" class="text-right">
                        {{ data.item.q3 ? data.item.q3 : "" }}
                    </div>
                </template>

                <template #cell(q4)="data">
                    <div v-if="format === 'eur'" class="text-right">
                        €&nbsp;{{ data.item.q4 | formatNumber }}
                    </div>
                    <div v-if="format === 'quantity'" class="text-right">
                        {{ data.item.q4 ? data.item.q4 : "" }}
                    </div>
                </template>

                <template #cell(total)="data">
                    <div v-if="format === 'eur'" class="text-right">
                        €&nbsp;{{ data.item.total | formatNumber }}
                    </div>
                    <div v-if="format === 'quantity'" class="text-right">
                        {{ data.item.total ? data.item.total : "" }}
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ProductService from "@/store/services/product.service";
import ProductGroupService from "@/store/services/productgroup.service";
import FilterBar from "@/components/list_filters/FilterBar";

export default {
    name: "ProductTable",
    components: {FilterBar},
    data() {
        return {
            fields: [
                { key: "description", label: this.$gettext("Description"), tdClass: "col-description coldesc" },
                { key: "group", label: this.$gettext("Product group"), tdClass: "col-group coldesc tablecol-sm" },
                { key: "q1", label: this.$gettext("Q1"), tdClass: "tablecol-sm text-right", thClass: "text-right" },
                { key: "q2", label: this.$gettext("Q2"), tdClass: "tablecol-sm text-right", thClass: "text-right" },
                { key: "q3", label: this.$gettext("Q3"), tdClass: "tablecol-sm text-right", thClass: "text-right" },
                { key: "q4", label: this.$gettext("Q4"), tdClass: "tablecol-sm text-right", thClass: "text-right" },
                { key: "total", label: this.$gettext("Year"), tdClass: "tablecol-sm text-right", thClass: "text-right" },
            ],
            items: [],
            productGroups: [],
            loading: true,
            tableKey: 0,
            format: "eur"
        }
    },
    computed: {
        ...mapGetters({ 
            getCompanyId: 'main/getCompanyId'
        }),
    },
    methods: {
        filtersChanged(filters) {
            this.loading = true;
            this.getProducts(filters);
        },
        getProducts(filters) {
            let year = filters.product_year;
            if (!year)
                year = new Date().getFullYear();

            let params = {
                company_profile: this.getCompanyId,
                year: year
            }
            
            ProductGroupService.list(params).then((response) => {
                this.productGroups = response.data;

                ProductService.report(params).then((response) => {
                    this.items = response.data;
                    this.prepareReportLines(filters.product_format);
                });
            });
        },
        prepareReportLines(format) {
            if (format === "quantity") {
                this.items.forEach((item) => {

                    item.q1 = item.Q1 ? item.Q1.total_quantity : 0;

                    item.q2 = item.Q2 ? item.Q2.total_quantity : 0;
                    
                    item.q3 = item.Q3 ? item.Q3.total_quantity : 0;
                    
                    item.q4 = item.Q4 ? item.Q4.total_quantity : 0;

                    item.total = item.q1 + item.q2 + item.q3 + item.q4;
                    this.format = "quantity";
                    this.tableKey++;
                });
            } else {
                this.items.forEach((item) => {

                    item.q1 = item.Q1 ? item.Q1.total_amount : 0;
                    
                    item.q2 = item.Q2 ? item.Q2.total_amount : 0;
                    
                    item.q3 = item.Q3 ? item.Q3.total_amount : 0;
                    
                    item.q4 = item.Q4 ? item.Q4.total_amount : 0;

                    item.total = item.q1 + item.q2 + item.q3 + item.q4;
                    this.format = "eur";
                    this.tableKey++;
                });
            }

            this.loading = false;
        },
        getGroupName(groupId) {
            if (groupId) {
                let group = this.productGroups.find((group) => group.id === groupId);
                console.log(groupId, this.productGroups)
                if (group)
                    return group.name;
            }
            return "";
        }
    }
}
</script>

<style lang="scss">
.product-report-table  {
    .col-description { font-size: 16px; }
    .col-group { font-size: 14px; }
    &.gk-table--headed {
      thead {
        background: none;
        text-transform: none;
        color: $colorTextBase;
        th {
          font-size: 1rem;
          padding: 1rem 0.75rem;
          font-weight: normal;
          font-family: DINNextLTPro-Medium, sans-serif;
        }
      }
      tbody {
        tr {
            cursor: initial;
        }
      }
    }
}

</style>